
export default "/assets/hand-thumb-up-micro.e8b2d78c.svg"